import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';

import AppRouter from './AppRouter.js'

// This is the ID of the div in your index.html file

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
    <AppRouter />
);
